/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/components/layouts/app.layouts.loader.component.ts.
 */
import {Component} from '@angular/core';
import {AppPageloaderService} from '../../services/app.pageloader.service';

/**
 * Zweck: Beschreibt class AppLayoutsLoaderComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    selector: 'app-loader',
    templateUrl: 'app.layouts.loader.component.html',
    styleUrls: ['app.layouts.loader.component.scss'],
    standalone: false
})
export class AppLayoutsLoaderComponent {
  static id = 'AppLayoutsLoaderComponent';

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(public loader: AppPageloaderService) {
  }
}

